import { create } from "zustand";

function getInitialStartDate() {
  const newDate = new Date();
  // newDate.setUTCHours(0, 0, 0, 0);
  // newDate.setUTCDate(newDate.getUTCDate() - 1);
  return newDate;
}

function getInitialEndDate() {
  const newDate = new Date();
  // newDate.setUTCHours(0, 0, 0, 0);
  // newDate.setUTCDate(newDate.getUTCDate() - 1);
  return newDate;
}

interface DateRange {
  from: Date | undefined;
  to?: Date | undefined;
}

type SelectRangeEventHandler = (range: DateRange | undefined) => void;

interface DateRangeState {
  dateRange: DateRange;
  setDateRange: SelectRangeEventHandler;
}

export const useDateRangeStore = create<DateRangeState>()((set) => ({
  dateRange: {
    from: getInitialStartDate(),
    to: getInitialEndDate(),
  },
  setDateRange: (range) => {
    // Your logic for updating the date range here
    // For simplicity, we'll just directly set the range
    set({ dateRange: range });
  },
}));
